var map = {
	"./000Thailand Post25.png": "oIdj",
	"./2C2P_Pte_Ltd 1.png": "+PdQ",
	"./COD.png": "xK71",
	"./EMS-ship.png": "HGh3",
	"./EMS.png": "F8RM",
	"./Facebookface.png": "9auV",
	"./Flash-Express.png": "tCUU",
	"./Flash-ship.png": "z5jH",
	"./Flash.png": "FHk9",
	"./Gosaas.png": "zRzm",
	"./Group.png": "dSQv",
	"./Kerry.png": "Vym6",
	"./Line.png": "L5LN",
	"./Rectangle 1989.png": "9Qa5",
	"./Rectangle-1989.png": "WPdG",
	"./Salepage.png": "vCe0",
	"./ThailandPost_Logo.png": "S4N+",
	"./_EMS-ship.png": "4Cdp",
	"./_filter-EMS.png": "Vnow",
	"./_i-thaipost.png": "wJD1",
	"./_logo.png": "X7a8",
	"./active-shipping-credit.png": "IPSm",
	"./add-wallet.png": "njCe",
	"./authorization/_body-bg.png": "9mnx",
	"./authorization/body-bg.png": "EumS",
	"./authorization/logo go_ship_02.png": "2eTF",
	"./authorization/logo-gosell.png": "Ql9c",
	"./b-facebook.png": "YE1q",
	"./b-flash.png": "Uoyk",
	"./b-kerry.png": "/fDn",
	"./b-line.png": "3h60",
	"./b-thpost.png": "YGiq",
	"./backgrounds/boxed_bg.png": "hLqB",
	"./backgrounds/boxed_bg_retina.png": "1kIq",
	"./backgrounds/panel_bg.png": "AtL5",
	"./backgrounds/seamless.png": "pPp0",
	"./backgrounds/user_bg1.png": "oDOZ",
	"./boxes.png": "ULNq",
	"./brands/Untitled-1.png": "UFKc",
	"./brands/adwords.png": "wFAF",
	"./brands/amazon.png": "ROZt",
	"./brands/bing.png": "F2TX",
	"./brands/dribbble.png": "FE4K",
	"./brands/facebook.png": "YEYk",
	"./brands/spotify.png": "w8F2",
	"./brands/tripadvisor.png": "D9NK",
	"./brands/twitter.png": "I82Z",
	"./brands/youtube.png": "VBhH",
	"./bt-kbank.png": "8d3Z",
	"./bt-scb.png": "RYQr",
	"./calendar-event.png": "AHnK",
	"./carriers/4-info.png": "0Uku",
	"./carriers/4.png": "InFN",
	"./carriers/5-info.png": "5CtU",
	"./carriers/5.png": "/hE8",
	"./carriers/6-info.png": "Bl3t",
	"./carriers/6.png": "2dg4",
	"./carriers/8-info.png": "ndX2",
	"./carriers/8.png": "uXfV",
	"./carriers/FLASH_EXPRESS.png": "BT0j",
	"./carriers/__5.png": "u4zg",
	"./carriers/c-info-dhl.png": "Rt0h",
	"./carriers/c-info-flash.png": "11vD",
	"./carriers/c-info-jt.png": "SN/M",
	"./carriers/c-info-kerry.png": "Vwq7",
	"./carriers/c-info-thaipost.png": "4h5I",
	"./carriers/i-jt.png": "A/72",
	"./carriers/i-kerry.png": "mqX/",
	"./carriers/info-dhl-logo.png": "4u+v",
	"./carriers/info-flash-logo.png": "M/+x",
	"./carriers/info-jt-logo.png": "TDwk",
	"./carriers/info-kerry-logo.png": "5OXP",
	"./carriers/info-thaipost-logo.png": "4h77",
	"./channels/1.png": "8YZk",
	"./channels/2.png": "sZjO",
	"./channels/3.png": "ezXf",
	"./coin.png": "tgek",
	"./coin2.png": "rc3b",
	"./coming-soon.png": "wPnU",
	"./contact-center1.png": "Un9I",
	"./contact-center2.png": "bzfE",
	"./contact-center3.png": "MWW8",
	"./contact-center4.png": "B98g",
	"./delivery-box.png": "Ptps",
	"./delivery.png": "9TJ6",
	"./demo_page.png": "SOR2",
	"./demo_page_2.png": "KqmB",
	"./demo_profile.png": "KRZM",
	"./demo_profile2.png": "Xr3C",
	"./demo_profile3.png": "P/Xn",
	"./demo_profile4.png": "x9/7",
	"./demo_profile5.png": "yJdV",
	"./demo_profile_call.png": "cvEW",
	"./dribbble.png": "AHEf",
	"./example_file.png": "7OuR",
	"./exclamation-circle-light-1.png": "jNRO",
	"./facebook-4.png": "6ydW",
	"./facebook4.png": "+BRZ",
	"./filter-EMS.png": "NL7T",
	"./filter-Kerry.png": "gakA",
	"./filter-jt.png": "PcnN",
	"./flash-right.png": "XieP",
	"./gosell.png": "8LLw",
	"./home/banner_pic.png": "IuNG",
	"./home/howto_pic.png": "4BUH",
	"./home/htb_order_pic.png": "z+/y",
	"./home/htb_product_pic.png": "pSkn",
	"./home/htb_shipping_pic.png": "2HzR",
	"./home/sub_banner_pic1.png": "/4js",
	"./home/sub_banner_pic2.png": "UrR3",
	"./i-crm.png": "o6zF",
	"./i-dhl.png": "Bp8L",
	"./i-facebook.png": "eJmM",
	"./i-flash.png": "aWJD",
	"./i-instragram.png": "WhA0",
	"./i-jt.png": "uxQP",
	"./i-kerry.png": "YQl+",
	"./i-line-oa.png": "3RbB",
	"./i-line.png": "uYuf",
	"./i-thaipost.png": "zTGV",
	"./i-tiktok.png": "4w3w",
	"./i-youtube.png": "rre2",
	"./i_facebook.png": "jLM/",
	"./i_line.png": "84Vc",
	"./i_telesales.png": "dQNV",
	"./i_tiktok.png": "IVlu",
	"./i_uniqlo.png": "i/ZZ",
	"./ic-telesale.png": "StOi",
	"./ic-tiktok.png": "Ihro",
	"./icon-bank.png": "MSDY",
	"./icon-credit.png": "gXTZ",
	"./icon-payment-kbank.png": "IpmS",
	"./icon-payment-qr.png": "Zr2o",
	"./icon-qr.png": "toTm",
	"./icon-static-sale.png": "b64n",
	"./icon-thai.png": "n93v",
	"./icon-us.png": "0gSp",
	"./iconNoStore.png": "042b",
	"./icon_logo_facebook.png": "xH0y",
	"./icon_logo_google.png": "5NYA",
	"./icon_logo_line.png": "ll+6",
	"./image-storecenter.png": "9TDJ",
	"./image.png": "sfoY",
	"./image667.png": "Wauk",
	"./image668.png": "4M+n",
	"./img-norty.png": "b1uo",
	"./img-products.png": "WAWx",
	"./img-sellfacebook.png": "YCu4",
	"./img-sendmail.png": "rLeQ",
	"./img-setupstore.png": "aOhX",
	"./img-sms.png": "UraY",
	"./img_dhl.png": "sZAG",
	"./integate-banner1.png": "WJUP",
	"./integate-banner2.png": "oTjf",
	"./integate-banner3.png": "MRN9",
	"./kbank.png": "dSsq",
	"./kerry-ship.png": "o4uI",
	"./ktb.png": "/d3r",
	"./lang/de.png": "XrhS",
	"./lang/es.png": "ylet",
	"./lang/gb.png": "g+Eq",
	"./lang/it.png": "YD0e",
	"./lang/ru.png": "EZNz",
	"./lang/ua.png": "meus",
	"./leads/Application.png": "7mP/",
	"./leads/Godealer.png": "705P",
	"./leads/Goshop.png": "awvr",
	"./leads/application2.png": "+MgK",
	"./leads/example_file.png": "8an0",
	"./leads/godealer2.png": "/UN9",
	"./leads/gosell.png": "z1ZQ",
	"./leads/gosell2.png": "G231",
	"./leads/goship.png": "L05Q",
	"./leads/goship2.png": "j+1Q",
	"./leads/goshop2.png": "hIPX",
	"./logo-Kbang 1.png": "TWuR",
	"./logo-Kbang-1.png": "+8C+",
	"./logo-gosell.png": "VMv+",
	"./logo.png": "+0LV",
	"./logo_dark.png": "hOhv",
	"./logo_demo.png": "SRJv",
	"./logo_go_ship.png": "aTDO",
	"./logo_goship.png": "ShJD",
	"./logo_icon_dark.png": "KOtm",
	"./logo_icon_light.png": "QQk+",
	"./logo_light.png": "vSXw",
	"./news/blog-view-demo.png": "bzZi",
	"./news/image378-1.png": "AE0w",
	"./news/image378-2.png": "UG1D",
	"./news/image378-3.png": "YwGW",
	"./news/news-demo1.png": "q8wD",
	"./news/news-demo2.png": "dA+c",
	"./news/news-demo3.png": "s52Y",
	"./news/news-demo4.png": "jU+i",
	"./news/news-demo5.png": "EsP/",
	"./no-image-v2.png": "TPrz",
	"./no_access_img.png": "o5LA",
	"./page_not_found.png": "Lpn3",
	"./payments/1.png": "+Af2",
	"./payments/2.png": "yIcz",
	"./payments/6.png": "dsMK",
	"./people.png": "4m07",
	"./pie-chart.png": "vxVO",
	"./placeholders/user.png": "1bu1",
	"./plans/gosell.png": "uQnZ",
	"./plans/goship.png": "zKSk",
	"./pnotify/danger.png": "sdoi",
	"./pnotify/default.png": "Y9c9",
	"./pnotify/info.png": "ifjv",
	"./pnotify/success.png": "bHdk",
	"./pnotify/warning.png": "2kux",
	"./product-1.png": "vFsi",
	"./product-2.png": "m9Lt",
	"./product-31.png": "QeVF",
	"./product-40.png": "S/XS",
	"./product-ship.png": "9jY1",
	"./qr-kbank.png": "TqQg",
	"./shipping-label/Dhl.png": "xbEn",
	"./shipping-label/Flash.png": "9j8+",
	"./shipping-label/J_t.png": "j6ju",
	"./shipping-label/Kerry.png": "ClW4",
	"./shipping-label/Suitable-Printer-01.png": "JHVK",
	"./shipping-label/Suitable-Printer-02.png": "xJUd",
	"./shipping-label/Thaipost.png": "LD4x",
	"./shipping-label/__Thaipost.png": "0BwV",
	"./shipping-label/dhl/label-01.png": "vDJ6",
	"./shipping-label/dhl/label-02.png": "A8gg",
	"./shipping-label/dhl/label-03.png": "Llfi",
	"./shipping-label/dhl/label-04.png": "bEir",
	"./shipping-label/dhl/thumb/thumb-01.png": "Nqnx",
	"./shipping-label/dhl/thumb/thumb-02.png": "cfVa",
	"./shipping-label/dhl/thumb/thumb-03.png": "c8AP",
	"./shipping-label/dhl/thumb/thumb-04.png": "PxRC",
	"./shipping-label/flash/label-01.png": "9u4J",
	"./shipping-label/flash/label-02.png": "f4Hn",
	"./shipping-label/flash/label-03.png": "xjTK",
	"./shipping-label/flash/label-04.png": "s5AU",
	"./shipping-label/flash/label-05.png": "T2FJ",
	"./shipping-label/flash/label-06.png": "W7aT",
	"./shipping-label/flash/label-07.png": "b9dU",
	"./shipping-label/flash/thumb/thumb-01.png": "4hv2",
	"./shipping-label/flash/thumb/thumb-02.png": "6xj+",
	"./shipping-label/flash/thumb/thumb-03.png": "qbyY",
	"./shipping-label/flash/thumb/thumb-04.png": "vLl3",
	"./shipping-label/j_t/label-01.png": "/viO",
	"./shipping-label/j_t/label-02.png": "qLwH",
	"./shipping-label/j_t/label-03.png": "HxWY",
	"./shipping-label/j_t/label-04.png": "hs6R",
	"./shipping-label/j_t/label-05.png": "7WbU",
	"./shipping-label/j_t/label-06.png": "eJoB",
	"./shipping-label/j_t/label-07.png": "UT6L",
	"./shipping-label/j_t/thumb/thumb-01.png": "4bf3",
	"./shipping-label/j_t/thumb/thumb-02.png": "cfX0",
	"./shipping-label/j_t/thumb/thumb-03.png": "ohqW",
	"./shipping-label/j_t/thumb/thumb-04.png": "mN0V",
	"./shipping-label/kerry/label-01.png": "Jl72",
	"./shipping-label/kerry/label-02.png": "MtAv",
	"./shipping-label/kerry/label-03.png": "Ayi7",
	"./shipping-label/kerry/label-04.png": "B6fg",
	"./shipping-label/kerry/thumb/thumb-01.png": "FAA3",
	"./shipping-label/kerry/thumb/thumb-02.png": "fmzp",
	"./shipping-label/kerry/thumb/thumb-03.png": "KbF3",
	"./shipping-label/kerry/thumb/thumb-04.png": "nE7f",
	"./shipping-label/logo_goship.png": "zbew",
	"./shipping-label/receipts/Tax_Invoice.png": "VOsV",
	"./shipping-label/receipts/thumb/thumb_Tax_Invoice.png": "BBgf",
	"./shipping-label/system/label-01.png": "WRoU",
	"./shipping-label/system/label-02.png": "5Xpa",
	"./shipping-label/system/label-03.png": "5PtN",
	"./shipping-label/system/label-04.png": "Y8rO",
	"./shipping-label/system/thumb/thumb-01.png": "79Y/",
	"./shipping-label/system/thumb/thumb-02.png": "EW6F",
	"./shipping-label/system/thumb/thumb-03.png": "QDhc",
	"./shipping-label/system/thumb/thumb-04.png": "1U27",
	"./shipping-label/thaipost/label-01.png": "svjS",
	"./shipping-label/thaipost/label-02.png": "bCrl",
	"./shipping-label/thaipost/label-03.png": "F9rd",
	"./shipping-label/thaipost/label-04.png": "qMkK",
	"./shipping-label/thaipost/label-05.png": "EAAR",
	"./shipping-label/thaipost/label-06.png": "y6Yf",
	"./shipping-label/thaipost/label-07.png": "A8Vd",
	"./shipping-label/thaipost/thumb/thumb-01.png": "PMIi",
	"./shipping-label/thaipost/thumb/thumb-02.png": "E3a3",
	"./shipping-label/thaipost/thumb/thumb-03.png": "LiMW",
	"./shipping-label/thaipost/thumb/thumb-04.png": "mvVd",
	"./signature.png": "JOWC",
	"./signature_light.png": "xkfU",
	"./thum-digital.png": "4pZ8",
	"./thum-ecom.png": "jweU",
	"./thum-global.png": "eK/A",
	"./thum-howto.png": "bwMn",
	"./tiktok.png": "OIFf",
	"./ui/datepicker_trigger.png": "8Xhk",
	"./ui/map_marker.png": "NohS",
	"./upload-images.png": "Q9vD",
	"./waiting-print.png": "wL7B",
	"./waiting_approve_wallet.png": "DCrw",
	"./waiting_approve_wallet22.png": "dgDV",
	"./watting.png": "rWqk"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "htCk";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images ^\.\/.*\.png$
// module id = htCk
// module chunks = 150